import { createTheme, type MantineTheme, Pagination } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantinePagination: PartialDeep<MantineTheme> = createTheme({
  components: {
    Pagination: Pagination.extend({
      defaultProps: {
        color: 'purple.5',
      },
    }),
  },
});
